/* jshint ignore:start */

'use strict';

(function (window, document, $) {

    // Mobile Navigation
    var navTrigger = $('.fn-mobile-nav-trigger');
    var closeNav = $('.fn-close-nav');
    var mobileNav = $('.fn-mobile-navigation');
    var dimmedElem = $('.dimmed-overlay');
    var widgetScrollThreshold = 310;
    var isWidgetVisible = window.scrollY < widgetScrollThreshold;
    (isWidgetVisible) ? document.body.classList.add("is-ncb-wiget-visible") : document.body.classList.remove("is-ncb-wiget-visible");

    // Add span element to parents
    mobileNav.find('li.menu-item-has-children').children('a').append('<span class="lnr lnr-chevron-down fn-mobile-has-children"></span>');

    navTrigger.click(function() {

        function clear() {
            removeDimmer();
            mobileNav.removeClass('active');
            navTrigger.removeClass('open');
        }

        if ($(this).hasClass('open') && mobileNav.hasClass('active')) {
            clear();
        } else {
            navTrigger.addClass('open');
            mobileNav.addClass('active');
            addDimmer(); 
        }

        // Show children
        $('.fn-mobile-has-children').click(function(e) {
            e.preventDefault();
            var self = $(this);

            $.each($('.fn-mobile-has-children'), function(key, item) {
                if ($(item)[0] !== self[0]) {
                    $(item).parent().siblings().removeClass('active');
                }
            });

            self.parent().next().toggleClass('active');
        });

        // More content
        if ($('.mobile-menu-item-more-content').length > 0) {
            // Add arrow to parents
            mobileNav.find('.mobile-menu-item-more-content').children('a').append('<span class="lnr lnr-chevron-down fn-mobile-more-content"></span>');

            $('.fn-mobile-more-content').on('click', function(e) {
                e.preventDefault();

                //$(this).parent().parent().parent().parent().next().toggleClass('active');
            });
        }

        $(document).keyup(function(e) {
            if ($('body').hasClass('site-dimmed')) {
                if (e.keyCode === 27) {
                    clear();
                }
            }
        });
    });

    // Hide booking button when the NCB widget is shown
    window.addEventListener('scroll', function(e) {
        if (window.scrollY < widgetScrollThreshold === isWidgetVisible) {
            // Do nothing
        } else {
            isWidgetVisible = window.scrollY < widgetScrollThreshold;
            (isWidgetVisible) ? document.body.classList.add("is-ncb-wiget-visible") : document.body.classList.remove("is-ncb-wiget-visible");
        }
    });



})(window, document, jQuery);